import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import { withStyles } from '@app/components/styles'
import {
  saveConditionDeviceStateInfo,
  saveConditionStateDescription,
  saveConditionType,
} from '@app/actions/scenes/currentSceneCreating'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { isIOS } from 'react-device-detect'
import SelectVirtualSwitchConditionState
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateCondition/VirtualSwitchCondition/SelectVirtualSwitchConditionState/SelectVirtualSwitchConditionState'
import SelectVirtualSwitchConditionStateIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateCondition/VirtualSwitchCondition/SelectVirtualSwitchConditionState/SelectVirtualSwitchConditionState'
import { withAccessDenied, withNotifications, withRouter } from '@app/hocs'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? withStyles(SelectVirtualSwitchConditionStateIOS) : withStyles(SelectVirtualSwitchConditionState)

const mapStateToProps = (state) => {
  const { isMobile } = state.mobileDetector
  const { isEditConditionMode, isChangeConditionStateMode } = state.scenes.currentSceneCreating
  const { conditionDeviceNumber } = state.scenes.currentSceneCreating.currentCondition
  return {
    isMobile,
    isEditConditionMode,
    isChangeConditionStateMode,
    conditionDeviceNumber,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
  saveConditionType,
  saveConditionStateDescription,
  saveConditionDeviceStateInfo,
}, dispatch)

enhance = withAccessDenied(enhance)
enhance = withNotifications(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const SelectVirtualSwitchConditionStateEnhanced = enhance

export default withRouter(SelectVirtualSwitchConditionStateEnhanced)
